import { atom } from "jotai";

import { PatronEditBooking } from "../../../types";
import {
  currentBookingAtom,
  currentSessionMemberShipTypeIdAtom,
  currentSessionUserClientIdAtom,
  defaultMembershipTypeIdAtom,
  originalBookingAtom,
  originalBookingOwnerClientIdAtom,
  remainingSlotCapacityAtom,
  pendingRequestGroupAtom,
} from "../../stores";

type Payload = {
  booking: PatronEditBooking.Booking;
  defaultMembershipTypeId: string | null;
  remainingSlotCapacity: number;
  currentSessionMemberShipTypeId: string;
  currentSessionUserClientId: string;
  originalBookingOwnerClientId: string;
  startSlotId: string;
};
export const initializeEditBookingModalAtom = atom(
  null,
  (get, set, payload: Payload) => {
    const booking = payload.booking;
    set(originalBookingAtom, booking);
    set(currentBookingAtom, booking);
    set(pendingRequestGroupAtom, null);
    set(defaultMembershipTypeIdAtom, payload.defaultMembershipTypeId);
    set(remainingSlotCapacityAtom, payload.remainingSlotCapacity);
    set(
      currentSessionMemberShipTypeIdAtom,
      payload.currentSessionMemberShipTypeId
    );
    set(currentSessionUserClientIdAtom, payload.currentSessionUserClientId);
    set(originalBookingOwnerClientIdAtom, payload.originalBookingOwnerClientId);
  }
);
